export function getBackendUrl() {
	const configUrl = window.__RUNTIME_CONFIG__?.REACT_APP_BACKEND_URL ?? ''

	// If set to "/", use the current browser port/origin (perfect for Nginx reverse proxies)
	if (configUrl === '/') {
		return '' // This causes fetch("/api/...") and io("") to hit the same port dynamically
	}

	// Default zero config ("") -> connects to backend port (3001) on the same host
	if (configUrl === '') {
		const defaultPort = window.__RUNTIME_CONFIG__?.BACKEND_PORT || '3001'
		return `${window.location.protocol}//${window.location.hostname}:${defaultPort}`
	}

	// Alternative port on the same host (e.g., ":3002")
	if (configUrl.startsWith(':')) {
		return `${window.location.protocol}//${window.location.hostname}${configUrl}`
	}

	// Explicit full URL
	return configUrl
}
